import mutations from './dataTransferEvent.mutations'
import actions from './dataTransferEvent.actions'
import getters from './dataTransferEvent.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
